import * as React from "react";
import {loadModelInfo} from "../../../api/models/ModelInfo";
import {Icon} from "bloomer";
// @ts-ignore
import marked from "marked";

interface IAboutProps {
    modelName: string;
}

interface IAboutState {
    loading: boolean;
    html: string;
}

class About extends React.Component<IAboutProps, IAboutState> {
    constructor(props: IAboutProps) {
        super(props);

        this.state = {
            loading: false,
            html: ""
        };
    }

    public componentDidMount() {
        this.loadData();
    }

    public loadData = async () => {
        this.setState({
            loading: true
        });
        let errorOccurred = false;
        const response = await loadModelInfo(this.props.modelName).catch(() => {
            this.setState({
                loading: false
            });
            errorOccurred = true;
        });
        if (errorOccurred) {
            return;
        }

        if (response && response.about) {
            this.setState({
                loading: false,
                html: marked(response.about)
            });
        }
    };

    public render() {
        if (this.state.loading) {
            return <div style={{textAlign: 'center'}}>
                <span>Loading...</span>
                <Icon className="fas fa-spinner fa-spin"/>
            </div>;
        }

        if (!this.state.html) {
            return <div style={{textAlign: 'center'}}>
                <span>Information couldn't be loaded for this model at the moment. Please try again later.</span>
            </div>;
        }

        return <div>
            <div style={{maxWidth: '800px'}} dangerouslySetInnerHTML={{__html: this.state.html}} />
        </div>;
    }
}

export default About;


// WEBPACK FOOTER //
// ./src/components/model/About/index.tsx